import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    data: {
      uid: null,
      email: null,
      displayName: null,
      area: null,
      complete: false,
    },
  }),

  actions: {
    setUser(user) {
      if (user) {
        this.data.uid = user.uid;
        this.data.email = user.email;
        this.data.displayName = user.displayName;
        this.data.complete = true;
      }
    },

    setUserData(userData) {
      if (userData) {
        this.data = { ...this.data, ...userData };
        this.data.complete = true;
      }
    },

    setArea(area) {
      this.data.area = area;
    },

    clearUser() {
      this.data.uid = null;
      this.data.email = null;
      this.data.displayName = null;
      this.data.area = null;
      this.data.complete = false;
    },
  },

  getters: {
    isComplete: (state) => state.data.complete,
    userId: (state) => state.data.uid,
    userArea: (state) => state.data.area,
    userData: (state) => state.data,
  },

  persist: true,
});
